<ul class="sub-menu-v2">
    <li sidebar2-checkbox-dropdown [class.open]="dropdownOpen" [ngClass]="dropDownClasses">
        <header (click)="headerLink()" class="sub-menu-v2--header">
            <label>Business Structure</label>
            <i class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
        </header>

        <ul class="tenantHier">
            <app-sidebar2-subpanel-tenant [tenant]="rootTenant" [dropDownClasses]="dropDownClasses" [depth]="2">
            </app-sidebar2-subpanel-tenant>
        </ul>
    </li>
</ul>
